module.exports = __webpack_public_path__ + "img/feature_buy_ph.c6dd9460.png";